import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/da';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/hr';
import 'dayjs/locale/it';
import 'dayjs/locale/nb';
import 'dayjs/locale/nl';
import 'dayjs/locale/pl';
import 'dayjs/locale/sl';
import 'dayjs/locale/sv';
import { useTranslation } from 'react-i18next'
import { capitaliseAllWords } from '@/helpers/stringUtils'

dayjs.extend(customParseFormat);

const APP_TO_DAYJS_LOCALE = {
  'en': 'en',
  'en-gb': 'en',
  'da': 'da',
  'es': 'es',
  'fr': 'fr',
  'it': 'it',
  'hr': 'hr',
  'nb': 'nb',
  'sv': 'sv',
  'de': 'de',
  'de-de': 'de',
  'nl': 'nl',
  'nl-nl': 'nl',
  'pl': 'pl',
  'sl': 'sl',
  'debug': 'en'
};

function resolveDayjsLocale(locale) {
  if (typeof locale !== 'string') {
    return 'en';
  }

  const normalizedLocale = locale.toLowerCase();

  if (APP_TO_DAYJS_LOCALE[normalizedLocale]) {
    return APP_TO_DAYJS_LOCALE[normalizedLocale];
  }

  const baseLocale = normalizedLocale.split('-')[0];
  if (APP_TO_DAYJS_LOCALE[baseLocale]) {
    return APP_TO_DAYJS_LOCALE[baseLocale];
  }

  return 'en';
}

export default  function DateLocalizer({
  input,
  parseFormat = 'dddd, D MMMM YYYY [at] hA', // for parsing input strings
  locale = 'en', // default to English
  dateFormat = 'dddd, D MMMM YYYY',
}) {
  const [datePart, setDatePart] = useState('');
  const [timePart, setTimePart] = useState('');
  const [hasTimePart, sethasTimePart] = useState(false);
  const { t } = useTranslation()

  useEffect(() => {
    let isActive = true;

    let m =
      typeof input === 'string'
        ? dayjs(input, parseFormat)
        : dayjs(input);

    if (!m.isValid()) {
      m = dayjs(input);
    }

    const applyFormattedParts = (resolvedLocale) => {
      if (!isActive) {
        return;
      }

      dayjs.locale(resolvedLocale);

      // English = 12h format (4pm), other locales = 24h format (16:00)
      const timeFormat = resolvedLocale.startsWith('en') ? 'h:mma' : 'HH:mm';
      setDatePart(dayjs(m).locale(resolvedLocale).format(dateFormat));
      setTimePart(dayjs(m).locale(resolvedLocale).format(timeFormat));
      sethasTimePart(typeof input === 'string' && /\d{1,2}:\d{2}/.test(input));
    };

    const preferredLocale = resolveDayjsLocale(locale);
    applyFormattedParts(preferredLocale);

    return () => {
      isActive = false;
    };
  }, [input, parseFormat, locale, dateFormat]);


return (
  <span>
    {capitaliseAllWords(datePart)}
    {hasTimePart && <> {capitaliseAllWords(t('timeConcatenation'))} {timePart.toLowerCase()}</>}
  </span>
);
}